import { Input } from '@bitcine/cinesend-theme'
import { useState } from 'react'
import { Lock } from '../icons'

const Identifier = ({ field, saveField }) => {
  const [name, setName] = useState(field.name)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('name') ?? false
  return (
    <Input
      label={{
        text: 'Field identifier',
        icon: { icon: isLocked ? Lock : '' },
      }}
      value={name}
      onChange={(e) => setName(e.target.value)}
      onBlur={() => saveField({ name })}
      disabled={isLocked}
    />
  )
}

export default Identifier
